import { render, staticRenderFns } from "./ContactChangePassword.vue?vue&type=template&id=5d8deb99&scoped=true&"
import script from "./ContactChangePassword.vue?vue&type=script&lang=js&"
export * from "./ContactChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./ContactChangePassword.vue?vue&type=style&index=0&id=5d8deb99&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8deb99",
  null
  
)

export default component.exports